var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { attrs: { shadow: "never", bordered: false } },
        [
          _c(
            "el-form",
            {
              ref: "formValidate",
              staticClass: "formValidate mt20",
              attrs: {
                rules: _vm.ruleValidate,
                model: _vm.formValidate,
                "label-width": "140px",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "默认好评开关：", prop: "autoReplySwitch" } },
                [
                  _c("el-switch", {
                    attrs: {
                      "active-value": 1,
                      "inactive-value": 0,
                      "active-text": "开启",
                      "inactive-text": "关闭",
                    },
                    model: {
                      value: _vm.formValidate.autoReplySwitch,
                      callback: function ($$v) {
                        _vm.$set(_vm.formValidate, "autoReplySwitch", $$v)
                      },
                      expression: "formValidate.autoReplySwitch",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "自动默认好评时间(天)：",
                    prop: "autoReplyTime",
                  },
                },
                [
                  _c("el-input-number", {
                    attrs: {
                      "controls-position": "right",
                      "step-strictly": "",
                      step: 1,
                      min: 0,
                    },
                    model: {
                      value: _vm.formValidate.autoReplyTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.formValidate, "autoReplyTime", $$v)
                      },
                      expression: "formValidate.autoReplyTime",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { label: "默认好评内容：", prop: "autoReplyContent" },
                },
                [
                  _c("el-input", {
                    staticClass: "from-ipt-width",
                    attrs: {
                      placeholder: "请输入默认好评内容",
                      type: "textarea",
                    },
                    model: {
                      value: _vm.formValidate.autoReplyContent,
                      callback: function ($$v) {
                        _vm.$set(_vm.formValidate, "autoReplyContent", $$v)
                      },
                      expression: "formValidate.autoReplyContent",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.submit } },
                    [_vm._v("提交")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }